<div *ngIf="loading" class="container" style="padding:40px 24px">
    Loading about page...
</div>

<div *ngIf="errorMessage" class="container" style="padding:40px 24px">
    <div class="alert error">{{ errorMessage }}</div>
</div>

<ng-container *ngIf="data && !loading">

    <!-- HERO -->
    <section class="page-hero about-hero-pro about-compact-hero">
        <div class="container">
            <div class="about-hero-content reveal">
                <span class="eyebrow">
                    <i></i> {{ data.hero.eyebrow }}
                </span>

                <h1>{{ data.hero.title }}</h1>

                <p>{{ data.hero.description }}</p>
            </div>
        </div>
    </section>

    <!-- COMPANY VIDEO -->
    <section class="section about-video-section-pro">
        <div class="container">

            <div class="section-head reveal">
                <div>
                    <span class="section-kicker">Company Video</span>
                    <h2>See IOSC capabilities in action.</h2>
                </div>

                <p>
                    A short company presentation video can help customers understand IOSC facilities,
                    services and operational capacity more clearly.
                </p>
            </div>

            <div class="about-video-shell reveal">
                <video #aboutVideo
                       controls
                       preload="metadata"
                       poster="assets/img/iosc/slider_seu-sucess-nossa-energia.jpg">
                    <source src="assets/video/iosc-company-video.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>

                <button class="about-video-play"
                        type="button"
                        *ngIf="!videoStarted"
                        (click)="playAboutVideo(aboutVideo)">
                    <span></span>
                </button>
            </div>

        </div>
    </section>

    <!-- UK OFFICE -->
    <section class="section office-zigzag-section">
        <div class="container">
            <div class="office-zigzag-grid">

                <div class="office-copy-card reveal">
                    <span class="section-kicker">United Kingdom</span>
                    <h2>Established in the UK, serving global oilfield operations.</h2>

                    <p>
                        International Oilfield Supply Co Ltd. (IOSC) is a reputable company established in the UK in 2003
                        with a primary focus on serving the oil and gas industry. Over the years, we have expanded our
                        operations overseas and have emerged as one of the leading manufacturers, suppliers, and distributors
                        in the global market.
                    </p>

                    <p>
                        Our specialized services cater to the dynamically developing oil and gas markets, with particular
                        emphasis on the Caspian, Middle East, and African regions.
                    </p>

                    <p>
                        Our strategically located offices and facilities in England, Qatar, Azerbaijan, Georgia, Kazakhstan,
                        Turkey, and the UAE allow us to deliver timely and high-quality integrated services to our clients.
                    </p>
                </div>

                <figure class="office-photo-card reveal">
                    <div class="office-photo-media">
                        <img src="assets/img/offices/uk-office.jpg" alt="IOSC UK office">
                    </div>

                    <figcaption>
                        <b>United Kingdom Office</b>
                        <span>International Oilfield Supply Co Ltd. (IOSC) UK office</span>
                    </figcaption>
                </figure>

            </div>
        </div>
    </section>

    <!-- BAKU OFFICE -->
    <section class="section office-zigzag-section office-zigzag-alt">
        <div class="container">
            <div class="office-zigzag-grid office-reverse">

                <div class="office-copy-card reveal">
                    <span class="section-kicker">Baku, Azerbaijan</span>
                    <h2>Certified supply, distribution and technical support.</h2>

                    <p>
                        Our team of highly trained specialists has a wealth of experience in the industry, both nationally
                        and internationally. With a clear understanding of our customers' needs and the necessary skills
                        and qualifications, our staff members can help you succeed in your business operations.
                    </p>

                    <p>
                        IOSC is a certified supplier and distributor of a full range of oilfield materials, having been
                        awarded the ISO 9001:2008 certificate for Quality Management Systems.
                    </p>

                    <p>
                        We also possess various licenses for dangerous goods management, high-pressure equipment testing,
                        hydraulic and industrial hoses crimping and testing, agricultural fertilizers importation, among others.
                    </p>
                </div>

                <figure class="office-photo-card reveal">
                    <div class="office-photo-media">
                        <img src="assets/img/offices/baku-office.jpg" alt="IOSC Baku Azerbaijan office">
                    </div>

                    <figcaption>
                        <b>Baku Azerbaijan Office</b>
                        <span>International Oilfield Supply Co Ltd. (IOSC) Baku Azerbaijan office</span>
                    </figcaption>
                </figure>

            </div>
        </div>
    </section>

    <!-- KAZAKHSTAN OFFICE -->
    <section class="section office-zigzag-section">
        <div class="container">
            <div class="office-zigzag-grid">

                <div class="office-copy-card reveal">
                    <span class="section-kicker">Kazakhstan</span>
                    <h2>Regional reach with reliable logistics support.</h2>

                    <p>
                        Our offices and facilities strategically located in Azerbaijan, Qatar, Georgia, and Kazakhstan enable us
                        to deliver timely and high-qualified integrated services to our clients, working closely with our
                        sister company, Rulewave Services, to offer efficient transportation packages at competitive prices.
                    </p>

                    <p>
                        At IOSC, we are committed to being your long-term partner in contributing to the further success
                        of your business operations in the region and beyond.
                    </p>

                    <p>
                        Our vision is to continue delivering quality products and services while prioritizing customer
                        satisfaction to maintain our position as a leading supplier and distributor in the oil and gas industry.
                    </p>
                </div>

                <figure class="office-photo-card reveal">
                    <div class="office-photo-media">
                        <img src="assets/img/offices/kazakhstan-office.jpg" alt="IOSC Kazakhstan office">
                    </div>

                    <figcaption>
                        <b>Kazakhstan Office</b>
                        <span>International Oilfield Supply Co Ltd. (IOSC) Kazakhstan office</span>
                    </figcaption>
                </figure>

            </div>
        </div>
    </section>

    <!-- OPERATIONAL STRENGTHS -->
    <section class="section about-strength-section">
        <div class="container">

            <div class="section-head reveal">
                <div>
                    <span class="section-kicker">Operational Strengths</span>
                    <h2>Built for complex oilfield and industrial requirements.</h2>
                </div>

                <p>
                    IOSC combines sourcing, certification, regional logistics and technical support
                    to help customers receive the right materials at the right time.
                </p>
            </div>

            <div class="strength-grid">

                <article class="strength-card reveal">
                    <h4>Global sourcing network</h4>
                    <p>
                        Products and materials are sourced from trusted manufacturers across Europe,
                        China, Turkey, the UAE, the USA and the United Kingdom.
                    </p>
                </article>

                <article class="strength-card reveal">
                    <h4>Certified supply capability</h4>
                    <p>
                        Quality management, dangerous goods handling, high-pressure testing and hose
                        crimping capabilities support safe and compliant operations.
                    </p>
                </article>

                <article class="strength-card reveal">
                    <h4>Regional logistics support</h4>
                    <p>
                        Offices across key operating regions help IOSC coordinate faster response,
                        documentation and customer support for project requirements.
                    </p>
                </article>

                <article class="strength-card reveal">
                    <h4>Long-term partnership</h4>
                    <p>
                        IOSC focuses on customer satisfaction, reliability and continuous service
                        improvement to support long-term business operations.
                    </p>
                </article>

            </div>

        </div>
    </section>

    <!-- REAL MAP -->
    <section class="section real-office-map-section">
        <div class="container">

            <div class="section-head reveal">
                <div>
                    <span class="section-kicker">Regional Presence</span>
                    <h2>Our offices and facilities across key operating regions.</h2>
                </div>

                <p>
                    IOSC maintains strategically located offices to support customers with responsive,
                    high-quality integrated services.
                </p>
            </div>

            <div class="real-office-map-card reveal">
                <div id="ioscOfficeMap" class="iosc-office-map"></div>
            </div>

            <div class="office-info-grid office-info-grid-clean reveal">

                <article class="office-clean-card">
                    <div class="office-flag">UK</div>
                    <div>
                        <h3>United Kingdom</h3>
                        <p>Suit 9, Woodside House, Woodside Avenue, Eastleigh, SO50 9NA United Kingdom</p>

                        <a href="tel:+442380650900">+44(0) 23 8065 0900</a>
                        <a href="mailto:sales@iosc.co.uk">sales@iosc.co.uk</a>
                    </div>
                </article>

                <article class="office-clean-card">
                    <div class="office-flag">QA</div>
                    <div>
                        <h3>Qatar</h3>
                        <p>Zone 24, Street 220, Building 149 Doha, Qatar</p>

                        <a href="tel:+97466407679">+974 6640 7679</a>
                        <a href="mailto:jasadov@iosc.qa">jasadov@iosc.qa</a>
                    </div>
                </article>

                <article class="office-clean-card">
                    <div class="office-flag">AZ</div>
                    <div>
                        <h3>Azerbaijan</h3>
                        <p>Salyan Highway, 32 km, Garadagh district, AZ1083</p>

                        <a href="tel:+994502242057">+99 (450) 22420 57</a>
                        <a href="mailto:office@iosc.az">office@iosc.az</a>
                    </div>
                </article>

                <article class="office-clean-card">
                    <div class="office-flag">GE</div>
                    <div>
                        <h3>Georgia</h3>
                        <p>Vake-saburtalo district, Sairme Hill N 31 Tbilisi Georgia</p>

                        <a href="tel:+995591069761">+99 (559) 1069761</a>
                        <a href="mailto:ali.rajabov@iosc.ge">ali.rajabov@iosc.ge</a>
                    </div>
                </article>

                <article class="office-clean-card">
                    <div class="office-flag">KZ</div>
                    <div>
                        <h3>Kazakhstan</h3>
                        <p>498 Seifullin str. BC Altyn Zaman office 305 Almaty 050012 Kazakhstan</p>

                        <a href="tel:+77279738470">+7 (727) 9738470</a>
                        <a href="mailto:office@ioscca.kz">office@ioscca.kz</a>
                    </div>
                </article>

            </div>

        </div>
    </section>

    <!-- REGIONAL SUPPORT CTA -->
    <section class="section regional-support-cta">
        <div class="container">
            <div class="regional-support-panel reveal">

                <div>
                    <span class="section-kicker">Regional Support</span>
                    <h2>Need oilfield materials, testing support or industrial supply coordination?</h2>

                    <p>
                        Share your requirement with IOSC and our team will review product availability,
                        documentation needs, delivery location and technical details.
                    </p>
                </div>

                <div class="regional-support-actions">
                    <a class="btn btn-primary" routerLink="/contact">
                        Send RFQ
                    </a>

                    <a class="btn btn-ghost" routerLink="/certificates">
                        View Certificates
                    </a>
                </div>

            </div>
        </div>
    </section>

  
    <!-- TIMELINE -->
    <section class="section timeline-section about-timeline-pro">
        <div class="container">

            <div class="section-head reveal">
                <div>
                    <span class="section-kicker">Company Journey</span>
                    <h2>From regional supplier to integrated industrial partner.</h2>
                </div>

                <p>
                    Timeline is presented as a capability growth story: foundation,
                    regional expansion, service depth and modern RFQ-driven customer support.
                </p>
            </div>

            <div class="timeline-pro">
                <article class="timeline-card reveal" *ngFor="let t of data.timeline">
                    <div class="timeline-year">{{ t.year }}</div>

                    <div class="timeline-dot"></div>

                    <div class="timeline-content">
                        <span class="tag">{{ t.tag }}</span>

                        <h3>{{ t.title }}</h3>

                        <p>{{ t.description }}</p>
                    </div>
                </article>
            </div>

        </div>
    </section>

</ng-container>
